/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_2f0cbb22',
  hasMediumDelay: 'hasMediumDelay_2f0cbb22',
  content: 'content_2f0cbb22',
  subText: 'subText_2f0cbb22',
};

export = styles;

loadStyles([{"rawString":".root_2f0cbb22{max-width:364px;background:"},{"theme":"white","defaultValue":"#ffffff"},{"rawString":";padding:8px;pointer-events:none}.root_2f0cbb22.hasMediumDelay_2f0cbb22{-webkit-animation-delay:.3s;animation-delay:.3s}.content_2f0cbb22{font-size:12px;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":";word-wrap:break-word;overflow-wrap:break-word}.subText_2f0cbb22{margin:0}"}]);
/* tslint:enable */